import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getApplicationList } from '../../../store/slices/Citizenship/viewDocumentSlice';
import "tabs-pattern/dist/foundation.css";
import Table from '../../../components/common/Table/Table';
import BreadCrumbs from '../../../components/common/BreadCrumbs/BreadCrumbs';
import UploadErrorBanner from './ViewDetails/UploadErrorBanner';
import 'card-pattern/dist/main.css';
import ScrollToTopBtn from '../../../components/common/ScrollToTopBtn';
import Loader from '../../../components/common/Loader';
import CardTable from '../../../components/common/CardTable';
import { trackButtonClick, trackNavigation, trackCustomPageView } from '../../../services/analytics';

interface TableColumn {
  key: string;
  label: string;
  className?: string;
}

interface TableRow {
  [key: string]: React.ReactNode;
}

const UplodadDocument: FC = () => {
  const navigate = useNavigate();

  const columns: TableColumn[] = [
    { key: 'id', label: 'Application ID' },
    { key: 'createdDate', label: 'Application Date' },
    { key: 'status', label: 'Status' },
    { key: 'totalFees', label: 'Total Fees' },
    { key: 'action', label: 'Action' },
  ];




  const handleActionClick = (rowData: TableRow) => {
    const id = (rowData as any).id ?? (rowData as any).id ?? (rowData as any).id ?? '';
    const createdDate = (rowData as any).createdDate ?? (rowData as any).createdDate ?? (rowData as any).createdDate ?? '';
    if (id) {
      console.log(`📊 Analytics: Upload documents/view details clicked - Application ${id}`);
      trackButtonClick('Upload documents/view details', 'upload-document-table', { applicationId: id });
      trackCustomPageView(`upload-document-details`);
      navigate(`/citizenship/detailstabs/${encodeURIComponent(String(id))}`, {
        state: { createdDate }
      });
    }
 
  };

  

  const handleBreadcrumbPrevious = (): void => {
    console.log('📊 Analytics: Navigate back to citizenship');
    trackNavigation('upload-document', 'citizenship', 'back');
    navigate('/citizenship'); // Navigate back to the reimbursement overview page
  }

  const dispatch = useAppDispatch();
  const { items, loading, error } = useAppSelector((state) => state.viewDocument as any);

  useEffect(() => {
    dispatch(getApplicationList({ page: 1, per_page: 10 }));
  }, [dispatch]);

  const rowsFromApi: TableRow[] = (items || []).map((item: any) => ({
    id: item.id ?? item.id ?? item.id ?? '',
    createdDate: item.createdDate ?? item.createdDate ?? item.createdDate ?? '',
    status: (
      <span className="bg-gray-100 border border-[#00000014] rounded px-3 py-1 text-sm font-semibold inline-flex items-center justify-center">
        {item.status ?? 'Unknown'}
      </span>
    ),
    totalFees: item.totalFees ?? item.total_fees ?? item.fees ?? '',
    action: 'Upload documents/view details',
  }));
  const renderContent = () => {
    if (loading) {
      return (
        <div className="py-8 flex justify-center items-center">
          <Loader />
        </div>
      );
    }

    if (error) {
      return (
        <div className="min-h-[65vh] flex items-center justify-center">
          <UploadErrorBanner
            header="Error fetching applications"
            message={error || 'An unexpected error occurred while fetching applications.'}
            className="mx-auto w-[70%]"
          />
        </div>
      );
    }

    if (items && items.length > 0) {
      return (
        <Table
          columns={columns}
          rows={rowsFromApi}
          onActionClick={handleActionClick}
          isSorting={false}
        />
      );
    }

    return (
      <div className="min-h-[65vh] flex items-center justify-center">
        <p className="p3 -book text-center mt-0">No applications found.</p>
      </div>
    );
  };

  return (
    <div className="min-h-screen !mt-[60px] lg:!px-[160px] sm:!px-5 mobile:!mx-[16px]" >
      <BreadCrumbs previousPage="Back to Citizenship fee assistance" currentPage="View my status and upload documents" onPreviousClick={handleBreadcrumbPrevious} stackOnMobile={true} />
      <div>
  <h1 className="h1 tablet:!mx-5 desktop:!mx-5 sm:!mx-0 !mt-[32px] !">View my status and Upload documents</h1>
      </div>
      <CardTable
        className="mb-8 px-4 mx-5 sm:mx-0 sm:px-0"
        aria-label="My citizenship fee applications"
      >
        <h3 className="h3">My citizenship fee applications</h3>
        <p className="p3 -book mb-4!">
          Submitted applications will be listed below.
        </p>
        {renderContent()}
      </CardTable>
      <ScrollToTopBtn mobileOnly={true} />
    </div>
  );
};

export default UplodadDocument;
